import { render, staticRenderFns } from "./CardReaderInsert.vue?vue&type=template&id=518da971&scoped=true"
import script from "./CardReaderInsert.vue?vue&type=script&lang=js"
export * from "./CardReaderInsert.vue?vue&type=script&lang=js"
import style0 from "./CardReaderInsert.vue?vue&type=style&index=0&id=518da971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518da971",
  null
  
)

export default component.exports